<div class="lum-modal">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">Pull Orders</span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        Close
      </button>
    </div>
  </div>
  <div class="lum-modal__body">
    <form
      [formGroup]="form"
      class="invoice-note-form__wrapper"
      (submit)="onSubmit()"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="">Select app integration accounts to pull orders</label>
            <mat-select
              class="lum-select"
              formControlName="appIntegrationAccountIds"
              multiple
              [ngClass]="{
                error:
                  form.get('appIntegrationAccountIds')?.invalid &&
                  form.get('appIntegrationAccountIds')?.touched,
              }"
            >
              <mat-select-trigger>
                {{
                  form.get('appIntegrationAccountIds')?.value?.length <= 2
                    ? selectedAppIntegrationAccounts
                    : form.get('appIntegrationAccountIds')?.value?.length +
                      ' selected'
                }}
              </mat-select-trigger>
              <mat-option
                *ngFor="let item of appIntegrationAccounts; trackBy: trackById"
                [value]="item.id"
              >
                {{ item.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('appIntegrationAccountIds')?.invalid">
              {{ form.get('appIntegrationAccountIds') | validateField }}
            </mat-error>
          </div>
        </div>
      </div>
      <div class="lum-modal__footer">
        <div class="flex ml-auto lum-modal__action">
          <button
            mat-button
            type="submit"
            class="lum-button"
            [disabled]="form.invalid"
          >
            Pull Orders
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
